var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},_vm._l((_vm.cols),function(col){return _c('chess-cell',{key:col,attrs:{"col":col,"row":_vm.row}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }